import React from 'react';
import { languageController } from '../../../controllers/language/languageController';

interface FormProps extends React.FormHTMLAttributes<HTMLFormElement> {
  className?: string;
  type?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  isDark?: boolean;
  children?: React.ReactNode;
  requiredFieldsHelperText?: boolean;
  errorMessage?: string;
}

const Form: React.FC<FormProps> = ({
  className = '',
  type,
  onSubmit,
  isDark = false,
  children,
  requiredFieldsHelperText = false,
  errorMessage,
  ...otherProps
}) => {
  return (
    <form
      className={[
        'mz-form',
        type ? `mz-form--${type}` : '',
        className,
        isDark ? 'mz-form--bg-dark' : '',
      ].join(' ')}
      onSubmit={onSubmit}
      {...otherProps}
    >
      {errorMessage && <p className={`caption ${isDark ? 'text--white' : 'text--red'}`}>{errorMessage}</p>}
      {requiredFieldsHelperText && <p className="mz-form__helper-text caption text--grey">* {languageController.getCopy('global', 'requiredFields')}</p>}
      {children}
    </form>
  );
};

export default Form;
